// import './App.css';
// import Context from './context';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import AdminSidebar from './components/AdminSidebar';
// import { Outlet, useLocation } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import apiCall from './helper/apiCall';
// import { setUser } from './store/userSlice';
// import { useDispatch } from 'react-redux';
// import { useEffect } from 'react';
// function App() {
//   const location = useLocation();
//    const dispatch = useDispatch();
//   // Define the path where we DON'T want the admin chrome (Sidebar/Header)
//   const isLoginPage = location.pathname === '/login';

//   const getSeller = async () => {
//     const response = await apiCall('getSeller');
//     if (response.success) {
//       dispatch(setUser(response.data));      
//     }
//   }

//   useEffect(() => {
//     getSeller();

  
    
//   }, []);

//   return (
//     <Context.Provider value={{getSeller}}>
//       <ToastContainer position='top-center' autoClose={2000} />
      
//       {isLoginPage ? (
//         /* --- 1. AUTH LAYOUT (Login Only) --- */
//         <main className="min-h-screen bg-slate-50">
//           <Outlet />
//         </main>
//       ) : (
//         /* --- 2. ADMIN PANEL LAYOUT (Dashboard, Collection, etc.) --- */
//         <div className='flex min-h-screen bg-slate-50'>
          
//           {/* Fixed Sidebar */}
//           <AdminSidebar />

//           {/* Main Content Wrapper */}
//           <div className='flex-1 flex flex-col h-screen overflow-hidden'>
            
//             {/* Admin Header */}
//             <Header />

//             {/* Scrollable Page Content */}
//             <main className='flex-1 overflow-y-auto p-4 lg:p-8'>
//               <div className='max-w-[1600px] mx-auto'>
//                 <Outlet />
//               </div>
              
//               <Footer />
//             </main>
//           </div>
//         </div>
//       )}
//     </Context.Provider>
//   );
// }

// export default App;

import React, { useEffect, useState, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import './App.css';
import Context from './context';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminSidebar from './components/AdminSidebar';
import apiCall from './helper/apiCall';
import { setUser } from './store/userSlice';

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  // Memoize getSeller so it can be passed in Context without triggering re-renders
  const getSeller = useCallback(async () => {
    try {
      const response = await apiCall('getSeller');
      if (response.success) {
        dispatch(setUser(response.data));
      }
    } catch (error) {
      console.error("Failed to fetch seller:", error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    getSeller();
  }, [getSeller]);

  const isLoginPage = location.pathname === '/login';

  // Prevent rendering protected parts of the app until we know the user status
  if (isLoading && !isLoginPage) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-lg font-semibold">Loading App...</p>
      </div>
    );
  }

  return (
    // <Context.Provider value={{ getSeller }}>
    //   <ToastContainer position='top-center' autoClose={2000} />
      
    //   {isLoginPage ? (
    //     <main className="min-h-screen bg-slate-50">
    //       <Outlet />
    //     </main>
    //   ) : (
    //     <div className='flex min-h-screen bg-slate-50'>
    //       <AdminSidebar />

    //       <div className='flex-1 flex flex-col h-screen overflow-hidden'>
    //         <Header />

    //         <main className='flex-1 overflow-y-auto p-4 lg:p-8'>
    //           <div className='max-w-[1600px] mx-auto'>
    //             <Outlet />
    //           </div>
    //           <Footer />
    //         </main>
    //       </div>
    //     </div>
    //   )}
    // </Context.Provider>
    <Context.Provider value={{ getSeller }}>
      <ToastContainer position='top-center' autoClose={2000} />
      
      {isLoginPage ? (
        <main className="min-h-screen bg-slate-50">
          <Outlet />
        </main>
      ) : (
        /* FIX: Ensure relative positioning and handle overflow correctly */
        <div className='flex min-h-screen bg-slate-50 relative overflow-x-hidden'>
          
          <AdminSidebar />

          {/* FIX: Removed 'h-screen overflow-hidden' to allow natural scrolling on mobile */}
          <div className='flex-1 flex flex-col min-w-0'>
            <Header />

            <main className='flex-1 p-4 lg:p-8 w-full'>
              <div className='max-w-[1600px] mx-auto'>
                <Outlet />
              </div>
              <Footer />
            </main>
          </div>
        </div>
      )}
    </Context.Provider>
  );
}

export default App;